module.exports = __webpack_public_path__ + "img/logo-rewords.9833c3d.png";